export default __webpack_public_path__ + "static/media/click.38da6178.mp4";